import { withInstall } from '@xzx-design/utils'
import _Dialog from './src/dialog'

export const Dialog = withInstall(_Dialog)
export default Dialog

export * from './src/dialog'
export * from './src/types'
export * from './src/function-call'
